// src/components/utiles/helpers.js

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const defaultPeriodoHoy = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = d.getMonth();
  const q = m < 3 ? 1 : m < 6 ? 2 : m < 9 ? 3 : 4;
  return `${y}Q${q}`;
};

export const fmtMoney = (v) => (Number.isFinite(+v) ? (+v).toFixed(2) : v ?? "");

export const toIntOrNull = (v) => {
  const n = Number(String(v ?? "").trim());
  return Number.isFinite(n) ? n : null;
};

export const allowOnlyDigits = (e) => {
  const k = e.key;
  if (["Backspace", "Delete", "Tab", "Enter"].includes(k) || k.startsWith("Arrow")) return;
  if (!/^\d$/.test(k)) e.preventDefault();
};

export const parseCodigos = (raw) =>
  Array.from(
    new Set(
      String(raw || "")
        .split(/[,\s;]+/)
        .map((x) => x.trim())
        .filter(Boolean)
        .map((x) => Number(x))
        .filter((n) => Number.isFinite(n))
    )
  );

export const toColegiadoCodigo = (d) =>
  d?.colegiadoCodigo ?? d?.colegiado_codigo ?? d?.colegiadoId ?? d?.colegiado_id;

export const codeFromRow = (d) => {
  if (!d || typeof d !== "object") return null;
  const direct =
    d.colegiadoCodigo ??
    d.colegiado_codigo ??
    d.colegiadoId ??
    d.colegiado_id ??
    d.codigoColegiado ??
    d.codigo_colegiado ??
    d.codigo ??
    d.colegiado ??
    null;
  if (direct) return String(direct).trim() || null;
  if (d.colegiado && typeof d.colegiado === "object") {
    const nested =
      d.colegiado.codigo ??
      d.colegiado.id ??
      d.colegiado.colegiadoCodigo ??
      d.colegiado.colegiado_codigo ??
      null;
    if (nested) return String(nested).trim() || null;
  }
  return null;
};

// Normalizadores de datos personales
export const buildNombreCompleto = (src = {}) => {
  const nombre =
    src.nombre ?? src.colegiadoNombre ?? src.nombreCompleto ?? src.nombre_completo ?? "";
  const a1 = src.apellido_1 ?? src.apellido1 ?? src.primer_apellido ?? "";
  const a2 = src.apellido_2 ?? src.apellido2 ?? src.segundo_apellido ?? "";
  return [nombre, a1, a2].map((s) => String(s || "").trim()).filter(Boolean).join(" ");
};
export const pickNif = (src = {}) => src.nif ?? src.NIF ?? src.nifNorm ?? src.nif_norm ?? "";
export const pickIban = (src = {}) =>
  src.iban ?? src.IBAN ?? src.ibanNorm ?? src.iban_norm ?? src.cuenta_Bancaria ?? src.cuenta ?? "";
export const pickLocalidad = (src = {}) => src.localidad ?? src.poblacion ?? src.municipio ?? "";
export const pickProvincia = (src = {}) => src.provincia ?? src.region ?? src.province ?? "";

// Estados
export const RECIBO_ESTADOS = ["COBRADO", "PENDIENTE", "PENDIENTE_DEVUELTO", "ANULADO"];

export const DEV_ESTADOS = [
  { code: 0, label: "PENDIENTE" },
  { code: 1, label: "PAGADA" },
  { code: 2, label: "COMPENSADO_DEVOLUCION" },
];

export const deduceDevEstadoNum = (d) => {
  if (d?.estado != null) return Number(d.estado);
  if (d?.estadoNum != null) return Number(d.estadoNum);
  if (d?.pagada) {
    const mot = String(d?.motivo || "").toUpperCase();
    return mot === "COMPENSADO_DEVOLUCION" ? 2 : 1;
  }
  return 0;
};
